import React from "react";
import { Modal, Typography } from "antd";
import { QuestionCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import ReactDOM from "react-dom";
type PopupTitleProps = { title: string };

export const PopupTitle = (props: PopupTitleProps) => (
  <Typography.Title level={3} className="m-0">
    {props.title}
  </Typography.Title>
);

export const Popup = (props) => {
  const { onCancel, content, title, destroyOnClose, closable, visibility, width, titleColor, style } = props;
  return (
    <Modal
      centered
      maskClosable={false}
      destroyOnClose={destroyOnClose}
      closable={closable}
      wrapClassName="check"
      open={visibility}
      bodyStyle={style ? style : { padding: "22px 60px 24px" }}
      okButtonProps={{ className: "ag-gray-button" }}
      cancelButtonProps={{ className: "ag-gray-button-outline" }}
      title={title ? titleColor ? <span style={titleColor}>{title}</span> : title : null}
      footer={null}
      width={width}
      onCancel={() => onCancel()}
    >
      {content}
    </Modal>
  );
};

export function PopupConfirm(props) {
  Modal.confirm({
    centered: true,
    maskClosable: false,
    closable: props?.closeable ? props?.closeable : false,
    // bodyStyle: { padding: "32px 32px 24px" },
    okButtonProps: { className: "ag-green-button" },
    cancelButtonProps: { className: "ag-gray-button-outline" },
    onCancel() {
      props?.onCancel && props?.onCancel();
    },
    autoFocusButton: null,
    icon: props?.showIcon === false ? null : <QuestionCircleOutlined />,
    okCancel: props?.okCancel === false ? false : true,
    ...props,
  });
}

export function PopupSuccess(props) {
  Modal.success({
    centered: true,
    maskClosable: false,
    closable: false,
    // bodyStyle: { padding: "32px 32px 24px" },
    okButtonProps: { className: "ag-green-button" },
    cancelButtonProps: { className: "ag-gray-button-outline" },
    autoFocusButton: null,
    icon: <CheckCircleOutlined />,
    ...props,
  });
}
